import DeleteArticleApi, { DeleteArticleRequest } from '../apis/delete-article';
import { Modal } from 'bootstrap';

const register = function(): void {

    const deleteModal = document.getElementById('delete-article-modal');
    if (!deleteModal)
        return;
    
    const modal = new Modal(deleteModal);
    
    const deleteModalButton = document.getElementById('modal-delete-btn');
    const errorMessage: HTMLElement = document.querySelector('[data-delete-article-error]');

    deleteModal.addEventListener('show.bs.modal', (ev: MouseEvent) => {
        const button = <HTMLElement>ev.relatedTarget;
        const id = button.getAttribute('data-article-id');
        deleteModal.setAttribute('data-selected-id', id);
        errorMessage.innerText = "";
    });
    
    deleteModalButton.addEventListener('click', ev => {
        const id = deleteModal.getAttribute('data-selected-id');
        
        const request: DeleteArticleRequest =  {
            ArticleId: id,
        };
        
        const response = DeleteArticleApi.DeleteArticle(request);
        const articleItem = document.querySelector(`[data-article-wrapper="${id}"]`);
        
        response.then(response => {
            if (response) {
                errorMessage.innerText = response;
            }
            else {
                articleItem.remove();
                modal.hide();
            }
        });
    });
}

export default {
    register
}